import React from "react";
import styles from "./divider.css";

export const Divider = () => {
	return <hr className={styles.divider} />;
};

export const TextDivider = ({ text }) => {
	return <div className={styles.textDivider}>{text}</div>;
};



// WEBPACK FOOTER //
// ./src/components/ui/divider/divider.js